/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function splitText(){
  if($('[data-split-text]').length){
    $('[data-split-text]').each(function(){
      if(!$('[data-split-text]').find('.text-line').length){
        var i = $(this).attr('id');
        var pos = '';
        if ($(window).width() < 768) {
          pos = 'data-aos-anchor-placement="bottom-bottom"';
        }
        $(this).text($(this).text());
        $(this).splitLines({
          tag: '<div class="text-line"><span class="aos-line" '+pos+' data-aos-once="true" data-aos="reveal-line" data-aos-duration="1000">',
          width: 'auto',
          keepHtml: true
        });
      }
    });
  }
}
function validatePhone(el) {
  var a = el.val();
  var filter = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
  if (filter.test(a)) {
    el.parent().find('.error').removeClass('visible');
  }else {
    el.parent().find('.error').addClass('visible');
  }
}
function heroText(){
  if($(this).scrollTop() > 100) {
    $('.hero-contents').addClass('disappear').removeClass('appear');
  } else {
    $('.hero-contents').removeClass('disappear').addClass('appear');;
  }
}
function heroHeight(){
  if($('.hero').length){
    $('.hero').each(function(){
      $(this).outerHeight($(window).innerHeight());
    });
  }
}
function resizedw(){
  heroHeight();
}
var resizeTimer;
var lastScrollTop = 0;
$(document).ready(function(){
  heroText();
  splitText();
  AOS.init();
  
  $('.contact-side-nav li').on('click',function(){
    var t = $('.contact-section#'+$(this).attr('data-id')).offset().top - 63;
    $("html, body").animate({ scrollTop: t }, 600);
  });
  //Collection Slider
  if($('.collection-slider').length > 0 ){
    $('.collection-slider .slider-wrapper').each(function(){
      var el = $(this);
      var itemPerSlide = 3;
      if($(window).width() < 641){
        itemPerSlide = 1;
      }
      if(!el.hasClass('flickity-enabled')){
        el.flickity({
          prevNextButtons: false,
          pageDots: false,
          contain: true,
          draggable: true,
          dragThreshold: 8,
          groupCells: true,
          on: {
            ready: function() {
              var totalChildren = itemPerSlide / $(this)[0].cells.length * 100;
              $($(this)[0].$element[0]).parents('.collection-slider').find('.slider-bar-inner').css('width',totalChildren + '%');
            },
            select: function() {
              var selectedIndex = $(this)[0].selectedIndex + 1;
              var sliderWidth = selectedIndex * itemPerSlide / $(this)[0].cells.length * 100;
              if(sliderWidth > 100){sliderWidth=100};
              $($(this)[0].$element[0]).parents('.collection-slider').find('.slider-bar-inner').css('width',sliderWidth + '%');
              
            },
            change: function( index ) {
              var selectedIndex = $(this)[0].selectedIndex + 1;
              var sliderWidth = selectedIndex * itemPerSlide / $(this)[0].cells.length * 100;
              var totalPos = Math.ceil($(this)[0].cells.length / itemPerSlide);
              if(sliderWidth > 100){sliderWidth=100};
              $($(this)[0].$element[0]).parents('.collection-slider').find('.slider-bar-inner').css('width',sliderWidth + '%');
              
              if(selectedIndex > 1){
                $($(this)[0].$element[0]).parents('.collection-slider').find('.arrow-left').removeClass('disabled');
              }else{
                 $($(this)[0].$element[0]).parents('.collection-slider').find('.arrow-left').addClass('disabled');
              }
              if(totalPos == selectedIndex){
                $($(this)[0].$element[0]).parents('.collection-slider').find('.arrow-right').addClass('disabled');
              }else{
                 $($(this)[0].$element[0]).parents('.collection-slider').find('.arrow-right').removeClass('disabled');
              }
            }
          }
        });
      }
    })
  }
  $('.collection-slider .arrow-right').on( 'click', function() {
    $(this).parents('.collection-slider').find('.slider-wrapper').flickity('next');
  });
  $('.collection-slider .arrow-left').on( 'click', function() {
    $(this).parents('.collection-slider').find('.slider-wrapper').flickity('previous');
  });
  $('.category-menu-trigger').on( 'click', function() {
    $('.category-menu-sidebar').addClass('visible').removeClass('not-visible');
    $('#main').addClass('override');
    //$('html,body').addClass('no-scroll');
  });
  $('.category-menu-close,.sidebar-overlay').on( 'click', function() {
    $('.category-menu-sidebar').addClass('not-visible').removeClass('visible');
    $('#main').removeClass('override');
    $('html,body').removeClass('no-scroll');
  });
  $('.product-accordion .accordion h4').on( 'click', function() {
    var contentsHeight = $(this).next().outerHeight();
    var close;
    if($(this).parent().hasClass('expanded')){
      close = true;
    }
    $(this).parents('.product-accordion').find('.accordion').removeClass('expanded').height(32);
    if(!close){
      $(this).parent().addClass('expanded').height(contentsHeight + 32);
    }
  });
  $('.faq h4').on( 'click', function() {
    var contentsHeight = $(this).next().outerHeight();
    if($(this).parent().hasClass('expanded')){
      $(this).parent().removeClass('expanded').height(28);
    }else{
      $(this).parent().addClass('expanded').height(contentsHeight + 28);
    }
  });
  if($('#collection-slider-product-recommendations').length){
    var existCondition = setInterval(function() {
     if ($('#collection-slider-product-recommendations .ProductItem ').length > 0) {
       clearInterval(existCondition);
       var el = $('#collection-slider-product-recommendations .slider-wrapper');
       var itemPerSlide = 3;
       if($(window).width() < 641){
         itemPerSlide = 1;
       }
       if(!el.hasClass('flickity-enabled')){
        el.flickity({
          prevNextButtons: false,
          pageDots: false,
          contain: true,
          draggable: true,
          dragThreshold: 8,
          groupCells: true,
          on: {
            ready: function() {
              var totalChildren = itemPerSlide / $(this)[0].cells.length * 100;
              $($(this)[0].$element[0]).parents('.collection-slider').find('.slider-bar-inner').css('width',totalChildren + '%');
            },
            select: function() {
              var selectedIndex = $(this)[0].selectedIndex + 1;
              var sliderWidth = selectedIndex * itemPerSlide / $(this)[0].cells.length * 100;
              if(sliderWidth > 100){sliderWidth=100};
              $($(this)[0].$element[0]).parents('.collection-slider').find('.slider-bar-inner').css('width',sliderWidth + '%');
              
            },
            change: function( index ) {
              var selectedIndex = $(this)[0].selectedIndex + 1;
              var sliderWidth = selectedIndex * itemPerSlide / $(this)[0].cells.length * 100;
              var totalPos = Math.ceil($(this)[0].cells.length / itemPerSlide);
              if(sliderWidth > 100){sliderWidth=100};
              $($(this)[0].$element[0]).parents('.collection-slider').find('.slider-bar-inner').css('width',sliderWidth + '%');
              
              if(selectedIndex > 1){
                $($(this)[0].$element[0]).parents('.collection-slider').find('.arrow-left').removeClass('disabled');
              }else{
                 $($(this)[0].$element[0]).parents('.collection-slider').find('.arrow-left').addClass('disabled');
              }
              if(totalPos == selectedIndex){
                $($(this)[0].$element[0]).parents('.collection-slider').find('.arrow-right').addClass('disabled');
              }else{
                 $($(this)[0].$element[0]).parents('.collection-slider').find('.arrow-right').removeClass('disabled');
              }
            }
          }
        });
      }
     }
    }, 100);
  }
  $("textarea").each(function () {
    this.setAttribute("style", "height:" + (this.scrollHeight) + "px;overflow-y:hidden;");
  }).on("input", function () {
    this.style.height = "auto";
    this.style.height = (this.scrollHeight) + "px";
  });
  // Precheckout
  if($("#precheckout-form").length){
    function initPreCheckout(){
      $('.minimum-error').hide();
      $('.minimum-error').prev().prop('disabled',false);
      $('.pc-section').addClass('revealed');
      if($('.pc-options input:checked').val() == 'Delivery'){
        $('.information-block').addClass('invisible');
        $('[data-option="delivery"]').addClass('visible');
        $('[data-option="pickup"]').removeClass('visible');
        $('[data-option="pickup"]').each(function(){
          if($(this).is('select')){
            $(this).find('option:first-child').prop('disabled', false).prop('selected', true);
          }
        });
        $('[data-option="delivery"]').each(function(){
          if($(this).is('select')){
            $(this).find('option:first-child').prop('disabled', true);
          }
        });
      }else{
        $('.information-block').addClass('invisible');
        $('.information-block').find('span').removeClass('visible');
        $('.information-block').find('[data-pickup]').addClass('visible');
        $('[data-option="delivery"]').each(function(){
          if($(this).is('select')){
            $(this).find('option:first-child').prop('disabled', false).prop('selected', true);
          }
        });
        $('[data-option="pickup"]').each(function(){
          if($(this).is('select')){
            $(this).find('option:first-child').prop('disabled', true);
          }
        });
        $('[data-option="delivery"]').removeClass('visible');
        $('[data-option="pickup"]').addClass('visible');
      }
      $('#pickup-date').datepicker().data('datepicker').clear();
      $('#delivery-date').datepicker().data('datepicker').clear();
    }
    
    
    //Datepicker
    if($('.datepicker-input').length){
      $.fn.datepicker.language['en'] = {
        days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        months: ['January','February','March','April','May','June', 'July','August','September','October','November','December'],
        monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        today: 'Today',
        clear: 'Clear',
        dateFormat: 'mm/dd/yyyy',
        timeFormat: 'hh:ii aa',
        firstDay: 1
      };

      var d = new Date();
      var startingDate = new Date();
      var UAEdate = new Date(d.toLocaleString('en-US', { timeZone: 'Asia/Dubai' }));
      var hours = UAEdate.getHours();
      var minute = UAEdate.getMinutes();
      var cutoff = $('.datepicker-block').attr('data-cutoff').split(':');
      var cutoffH = cutoff[0];
      var cutoffM = cutoff[1];
      if(hours > cutoffH){
        startingDate.setDate(UAEdate.getDate() + 2);
      } else if(hours == cutoffH){
        if(minute > cutoffM){
          startingDate.setDate(UAEdate.getDate() + 2);
        }else{
          startingDate.setDate(UAEdate.getDate() + 1);
        }
      }else{
        startingDate.setDate(UAEdate.getDate() + 1);
      }


      $('.datepicker-input').datepicker({
        dateFormat : 'MM dd, yyyy',
        language : 'en',
        minDate : startingDate,
        onSelect: function(formattedDate, date, inst) {
          var myDatepicker = $('.datepicker-input').data('datepicker');
		  myDatepicker.hide();
        }
      });
      $('.datepicker-input').on('click', function(e) {
        e.preventDefault();
        $(this).attr("autocomplete", "off");  
      });
    }
    //Delivery
    function minimumOrder(min,total){
      if(min > total){
        var diff = min-total;
        var diffMoney = Shopify.formatMoney(diff, $('body').attr('data-format'));
        var minMoney = Shopify.formatMoney(min, $('body').attr('data-format'));
        $('.minimum-error').find('#diff_amount').text(diffMoney);
        $('.minimum-error').find('#minimum_amount').text(minMoney);
        $('.minimum-error').show();
        $('.minimum-error').prev().prop('disabled',true);
      }else{
        $('.minimum-error').hide();
        $('.minimum-error').prev().prop('disabled',false);
      }
    }
    //Delivery
    function deliveryChange(el,predefined){
      var state = el.find('option:selected').val();
      
      //Minimum
      if(el.find('option:selected').attr('data-minimum')){
        var minimum = parseInt(el.find('option:selected').attr('data-minimum'))*100;
        var total = parseInt($('#total-cart').attr('data-cart-total'));
        minimumOrder(minimum,total);
      }else{
      	$('.minimum-error').hide();
        $('.minimum-error').prev().prop('disabled',false);
      }
      
      //District Option
      var options = $('#all-districts option[data-state="'+state+'"]').clone();
      $('#districts option').not(':first').remove();
      $('#districts').append(options);
      $('#districts').find('option:first-child').prop('selected', true);
      //Info
      $('.information-block').removeClass('invisible').find('.location-name').text(state);
      $('.information-block').find('span').removeClass('visible');
      $('.information-block').find('[data-state="'+state+'"]').addClass('visible');

      //Calendar
      var disabledDays = el.find('option:selected').attr('data-dayoff');
      var deliverDate =  $('#delivery-date').datepicker().data('datepicker');
      deliverDate.clear();
      deliverDate.update({
        onRenderCell: function (date, cellType) {
          if (cellType == 'day') {
            var day = date.getDay();
            var dayFormatted = date.getDate()+'/'+(parseInt(date.getMonth())+1)+'/'+date.getFullYear();
            var isDisabled = false;
            if(disabledDays.indexOf(day)!= -1){
              isDisabled = true;
            }
            return {
              disabled: isDisabled
            }
          }
        }
      });
      if(predefined){
        var selectedDate = $('#delivery-date').attr('data-value').replace(',','').split(" ");
        var months = ['January','February','March','April','May','June', 'July','August','September','October','November','December'];
        deliverDate.selectDate(new Date(selectedDate[2],months.indexOf(selectedDate[0]), selectedDate[1]));
      }
    }
    function pickupChange(el,predefined){
      var state = el.find('option:selected').val();
      //District Option
      var options = $('#all-time option[data-state="'+state+'"]').clone();
      $('#time-window option').not(':first').remove();
      $('#time-window').append(options);
      $('#time-window').find('option:first-child').prop('selected', true);
      
      //Minimum
      if(el.find('option:selected').attr('data-minimum')){
        var minimum = parseInt(el.find('option:selected').attr('data-minimum'))*100;
        var total = parseInt($('#total-cart').attr('data-cart-total'));
        minimumOrder(minimum,total);
      }else{
      	$('.minimum-error').hide();
        $('.minimum-error').prev().prop('disabled',false);
      }
      
      //Calendar
      var disabledDays = el.find('option:selected').attr('data-dayoff');
      var deliverDate = $('#pickup-date').datepicker().data('datepicker');
      deliverDate.clear();
      deliverDate.update({
        onRenderCell: function (date, cellType) {
          if (cellType == 'day') {
            var day = date.getDay();
            var dayFormatted = date.getDate()+'/'+(parseInt(date.getMonth())+1)+'/'+date.getFullYear();
            var isDisabled = false;
            if(disabledDays.indexOf(day)!= -1){
              isDisabled = true;
            }
            return {
              disabled: isDisabled
            }
          }
        }
      });

      if(predefined){
        var selectedDate = $('#pickup-date').attr('data-value').replace(',','').split(" ");
        var months = ['January','February','March','April','May','June', 'July','August','September','October','November','December'];
        deliverDate.selectDate(new Date(selectedDate[2],months.indexOf(selectedDate[0]), selectedDate[1]));
      }
    }

    $('#delivery-location').on('change',function(){
      deliveryChange($(this));
    });
    $('#pickup-location').on('change',function(){
      pickupChange($(this));
    });

    $("#precheckout-form").validate({
      focusInvalid: false,
      submitHandler: function(form) {
        $('.pc-section').addClass('loading');
        form.submit();
      }
    });
  
    $('.pc-options input').on( 'click', function() {
      initPreCheckout();
    });
    if($('.pc-section').attr('data-selected') != ''){
      initPreCheckout();
      if($('.pc-section').attr('data-selected') == 'Delivery'){
        var el = $('#delivery-location');
        deliveryChange(el,true);
      }else{
        var el = $('#pickup-location');
        pickupChange(el,true);
      }
    }
  } 
  //Ajax ATC
  function closeCartDrawer(){
    $('#sidebar-cart').attr('aria-hidden', 'true');
    $(document).removeClass('no-scroll');
    disableBodyScroll(false, '[data-scrollable]');
    $('#shopify-section-header').css('z-index',''); // Ugly hack
    $('.PageOverlay').removeClass('is-visible');
    $('.PageOverlay').off('click');
    $('.Drawer__Close[data-drawer-id="sidebar-cart"]').off('click');
  }
  $('.atc-ajax').on('click',function(){
    var variant_id = $(this).attr('data-id');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: variant_id
      },
      dataType: 'json',
      success: function() {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        
        $('#sidebar-cart').attr('aria-hidden', 'false');
        $('#sidebar-cart').css('max-height', window.innerHeight+'px');
        $(document).addClass('no-scroll');
        disableBodyScroll(true, '[data-scrollable]');
        $('#shopify-section-header').css('z-index',''); // Ugly hack
        $('.PageOverlay').addClass('is-visible');
        $('.PageOverlay').on('click',closeCartDrawer);
        $('.Drawer__Close[data-drawer-id="sidebar-cart"]').on('click',closeCartDrawer);
        
      },
      error: function (xhr, ajaxOptions, thrownError) {
        console.log(xhr.status);
        console.log(thrownError);
      }
    });
  });
  document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant;
    if($('body').hasClass('template-product')){
      var minimum = $('select[name="id"] option[value="'+variant.id+'"]').attr('data-minimum');
      var unit = $('.ProductForm__Variants').attr('data-unit');
      if(minimum){
        $('.minimum-order').addClass('visible').find('.amount').text(minimum);
        $('[name="quantity"]').attr('min',minimum);
      }else{
        $('.minimum-order').removeClass('visible');
        $('[name="quantity"]').removeAttr('min');
        $('[name="quantity"]').val(1);
      }
      if(unit){
        $('.minimum-order').find('.unit').text(unit);
      }
      
      var q = $('[name="quantity"]');
      var min = q.attr('min');
      if(min){
        q.val(Math.max(parseInt(q.val()), min));
      }
      
    }
  });
  $('[name="quantity"]').on('change',function(){
    var min = $(this).attr('min');
    if(min){
      $(this).val(Math.max(parseInt($(this).val()), min));
    }
  });
  if($('.Product__Slideshow_v2 .Product__SlideItem').length > 1){
    var el = $('.Product__Slideshow_v2');
    el.flickity({
      prevNextButtons: true,
      pageDots: false,
      wrapAround: true,
      adaptiveHeight: true,
      contain: true,
      dragThreshold: 8,
      initialIndex: 0,
      imagesLoaded: true,
      lazyLoad: 3,
      groupCells : true,
      adaptiveHeight: true,
      cellAlign: 'right',
      arrowShape: "M91.11,49.15H7.01l22.93-23.14l-0.71-0.7c-8.04,8.12-16.08,16.23-24.12,24.35c0.4,0.41,0.81,0.81,1.21,1.22 C13.95,58.58,21.59,66.29,29.22,74l0.71-0.7L7.01,50.15h84.1V49.15z",
      on:{
        change: function(index) {
          var current= index + 1;
          if(current < 10){
            current = '0'+current;
          }
          if(el.hasClass('with-duplicate')){
            var total = el.find('.flickity-slider').children().length / 2;
            if(current > total){
              current = '0' + (current - total);
            }
          }
          $('.gallery-nav-inner .current').text(current);
        }
      }
    });
  }
  
});

$(window).scroll(function() {
  var st = $(this).scrollTop();
  heroText();

  if($('.contact-side-nav').length){
    $('.contact-section').each(function(){
      if($(this).offset().top - $(window).scrollTop() < 200) {
        $(".contact-side-nav li[data-id='"+$(this).attr('id')+"']").addClass('active').siblings().removeClass('active');
      }
    });
  }
  if (st > lastScrollTop){
    if($(window).scrollTop() > $('#shopify-section-header').outerHeight()){
      $('#shopify-section-header').addClass('header-stick').removeClass('header-unstick');
    }
  } else {
    if($(window).scrollTop() < $('#shopify-section-header').outerHeight()){
      $('#shopify-section-header').removeClass('header-stick').addClass('header-unstick');
    }
  }
    
  $(".parallax_element").each(function(){
    var offset = 0;
    offset = offset - (st - $(this).parents('.parallax_parent').offset().top);
    if($(this).hasClass('hero-image')){
      offset = offset * -1;
    }else{
      if(offset < -300){
        offset = -300;
      }else if(offset > 300){
        offset = 300;
      }
    }
    var transformY = offset * (parseFloat($(this).attr('data-friction')) / 50);
    
    $(this).css('transform','translate3d(0,'+transformY+'px,0)');
  });
    
  lastScrollTop = st;
});

window.onbeforeunload = function () {
  window.scrollTo(0, 0);
}
$(window).on( "pageshow", function ( event ) {
  var preCheckout = document.getElementById("shopify-section-precheckout");
  if(preCheckout){
    var historyTraversal = event.persisted || (typeof window.performance != "undefined" && window.performance.navigation.type === 2 );
    if ( historyTraversal ) {
      window.location.reload();
    }
  }
});
$(window).on('load', function(){
  heroHeight();
});
$(window).on('resize', function(){
  splitText();
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    heroHeight();
  }, 200);
});